module.exports = __webpack_public_path__ + "static/media/vertical_option_mobile.dfc2bc54.jpg";